/*
 * October Jaipur - header currency switcher
 * ---------------------------------------------------------------------------
 * Vanilla-JS port of the old "Speed October Jaipur <> UnfoldCRO" theme's
 * assets/currencies.js (the WPBingo `.bwp_currency` selector).
 *
 * Same behaviour as the old theme:
 *   - display-only conversion of every `span.money` on the page
 *   - same money-format table, same `currency` cookie (365 days)
 *   - same geo auto-detect -> preselect the visitor's currency
 *   - same optional rounding and hover tooltip showing the original price
 *
 * Differences from the old theme (no behaviour change):
 *   - no jQuery dependency (Dawn does not ship jQuery)
 *   - a MutationObserver re-converts prices that Shopify's section rendering
 *     injects later (cart drawer, variant change, quick add, facets), which
 *     the old theme did with hand-placed Currency.Currency_customer(true) calls
 *   - the geo lookup result is cached in localStorage['bwp_currency'], which
 *     the old code already read but never wrote
 *
 * Requires /services/javascripts/currencies.js first: it defines
 * Currency.rates and Currency.convert.
 */
(function () {
  'use strict';

  if (typeof window.Currency === 'undefined') {
    window.Currency = {};
  }

  var Currency = window.Currency;
  var routes = window.routes || {};

  var shop_currency = routes.shop_currency || 'USD';
  var auto_currency = String(routes.auto_currency) === 'true';
  var round_currency = String(routes.round_currency) === 'true';
  var hover_currency = String(routes.hover_currency) === 'true';

  Currency.currentCurrency = '';
  Currency.format = routes.currency_format || 'money_format';

  var PRICE_SELECTOR = 'span.money';
  var dt_cur_shop = 'data-currency-' + shop_currency;
  var dt_base = 'data-currency-base';

  var moneyFormats = {
          "USD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} USD"
          },
          "EUR": {
            "money_format": "&euro;{{amount}}",
            "money_with_currency_format": "&euro;{{amount}} EUR"
          },
          "GBP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} GBP"
          },
          "CAD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} CAD"
          },
          "ALL": {
            "money_format": "Lek {{amount}}",
            "money_with_currency_format": "Lek {{amount}} ALL"
          },
          "DZD": {
            "money_format": "DA {{amount}}",
            "money_with_currency_format": "DA {{amount}} DZD"
          },
          "AOA": {
            "money_format": "Kz{{amount}}",
            "money_with_currency_format": "Kz{{amount}} AOA"
          },
          "ARS": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
          },
          "AMD": {
            "money_format": "{{amount}} AMD",
            "money_with_currency_format": "{{amount}} AMD"
          },
          "AWG": {
            "money_format": "Afl{{amount}}",
            "money_with_currency_format": "Afl{{amount}} AWG"
          },
          "AUD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} AUD"
          },
          "BBD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} Bds"
          },
          "AZN": {
            "money_format": "m.{{amount}}",
            "money_with_currency_format": "m.{{amount}} AZN"
          },
          "BDT": {
            "money_format": "Tk {{amount}}",
            "money_with_currency_format": "Tk {{amount}} BDT"
          },
          "BSD": {
            "money_format": "BS${{amount}}",
            "money_with_currency_format": "BS${{amount}} BSD"
          },
          "BHD": {
            "money_format": "{{amount}} BD",
            "money_with_currency_format": "{{amount}} BHD"
          },
          "BYR": {
            "money_format": "Br {{amount}}",
            "money_with_currency_format": "Br {{amount}} BYR"
          },
          "BZD": {
            "money_format": "BZ${{amount}}",
            "money_with_currency_format": "BZ${{amount}} BZD"
          },
          "BTN": {
            "money_format": "Nu {{amount}}",
            "money_with_currency_format": "Nu {{amount}} BTN"
          },
          "BAM": {
            "money_format": "KM {{amount_with_comma_separator}}",
            "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
          },
          "BRL": {
            "money_format": "R$ {{amount_with_comma_separator}}",
            "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
          },
          "BOB": {
            "money_format": "Bs{{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
          },
          "BWP": {
            "money_format": "P{{amount}}",
            "money_with_currency_format": "P{{amount}} BWP"
          },
          "BND": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} BND"
          },
          "BGN": {
            "money_format": "{{amount}} Ð»Ð²",
            "money_with_currency_format": "{{amount}} Ð»Ð² BGN"
          },
          "MMK": {
            "money_format": "K{{amount}}",
            "money_with_currency_format": "K{{amount}} MMK"
          },
          "KHR": {
            "money_format": "KHR{{amount}}",
            "money_with_currency_format": "KHR{{amount}}"
          },
          "KYD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} KYD"
          },
          "XAF": {
            "money_format": "FCFA{{amount}}",
            "money_with_currency_format": "FCFA{{amount}} XAF"
          },
          "CLP": {
            "money_format": "${{amount_no_decimals}}",
            "money_with_currency_format": "${{amount_no_decimals}} CLP"
          },
          "CNY": {
            "money_format": "&#165;{{amount}}",
            "money_with_currency_format": "&#165;{{amount}} CNY"
          },
          "COP": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} COP"
          },
          "CRC": {
            "money_format": "&#8353; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
          },
          "HRK": {
            "money_format": "{{amount_with_comma_separator}} kn",
            "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
          },
          "CZK": {
            "money_format": "{{amount_with_comma_separator}} K&#269;",
            "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
          },
          "DKK": {
            "money_format": "{{amount_with_comma_separator}}",
            "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
          },
          "DOP": {
            "money_format": "RD$ {{amount}}",
            "money_with_currency_format": "RD$ {{amount}}"
          },
          "XCD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "EC${{amount}}"
          },
          "EGP": {
            "money_format": "LE {{amount}}",
            "money_with_currency_format": "LE {{amount}} EGP"
          },
          "ETB": {
            "money_format": "Br{{amount}}",
            "money_with_currency_format": "Br{{amount}} ETB"
          },
          "XPF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
          },
          "FJD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "FJ${{amount}}"
          },
          "GMD": {
            "money_format": "D {{amount}}",
            "money_with_currency_format": "D {{amount}} GMD"
          },
          "GHS": {
            "money_format": "GH&#8373;{{amount}}",
            "money_with_currency_format": "GH&#8373;{{amount}}"
          },
          "GTQ": {
            "money_format": "Q{{amount}}",
            "money_with_currency_format": "{{amount}} GTQ"
          },
          "GYD": {
            "money_format": "G${{amount}}",
            "money_with_currency_format": "${{amount}} GYD"
          },
          "GEL": {
            "money_format": "{{amount}} GEL",
            "money_with_currency_format": "{{amount}} GEL"
          },
          "HNL": {
            "money_format": "L {{amount}}",
            "money_with_currency_format": "L {{amount}} HNL"
          },
          "HKD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "HK${{amount}}"
          },
          "HUF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
          },
          "ISK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
          },
          "INR": {
            "money_format": "Rs. {{amount}}",
            "money_with_currency_format": "Rs. {{amount}}"
          },
          "IDR": {
            "money_format": "{{amount_with_comma_separator}}",
            "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
          },
          "ILS": {
            "money_format": "{{amount}} NIS",
            "money_with_currency_format": "{{amount}} NIS"
          },
          "JMD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} JMD"
          },
          "JPY": {
            "money_format": "&#165;{{amount_no_decimals}}",
            "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
          },
          "JEP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} JEP"
          },
          "JOD": {
            "money_format": "{{amount}} JD",
            "money_with_currency_format": "{{amount}} JOD"
          },
          "KZT": {
            "money_format": "{{amount}} KZT",
            "money_with_currency_format": "{{amount}} KZT"
          },
          "KES": {
            "money_format": "KSh{{amount}}",
            "money_with_currency_format": "KSh{{amount}}"
          },
          "KWD": {
            "money_format": "{{amount}} KD",
            "money_with_currency_format": "{{amount}} KWD"
          },
          "KGS": {
            "money_format": "Ð»Ð²{{amount}}",
            "money_with_currency_format": "Ð»Ð²{{amount}}"
          },
          "LVL": {
            "money_format": "Ls {{amount}}",
            "money_with_currency_format": "Ls {{amount}} LVL"
          },
          "LBP": {
            "money_format": "L&pound;{{amount}}",
            "money_with_currency_format": "L&pound;{{amount}} LBP"
          },
          "LTL": {
            "money_format": "{{amount}} Lt",
            "money_with_currency_format": "{{amount}} Lt"
          },
          "MGA": {
            "money_format": "Ar {{amount}}",
            "money_with_currency_format": "Ar {{amount}} MGA"
          },
          "MKD": {
            "money_format": "ден {{amount}}",
            "money_with_currency_format": "ден {{amount}} MKD"
          },
          "MOP": {
            "money_format": "MOP${{amount}}",
            "money_with_currency_format": "MOP${{amount}}"
          },
          "MVR": {
            "money_format": "Rf{{amount}}",
            "money_with_currency_format": "Rf{{amount}} MRf"
          },
          "MXN": {
            "money_format": "$ {{amount}}",
            "money_with_currency_format": "$ {{amount}} MXN"
          },
          "MYR": {
            "money_format": "RM{{amount}} MYR",
            "money_with_currency_format": "RM{{amount}} MYR"
          },
          "MUR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} MUR"
          },
          "MDL": {
            "money_format": "{{amount}} MDL",
            "money_with_currency_format": "{{amount}} MDL"
          },
          "MAD": {
            "money_format": "{{amount}} dh",
            "money_with_currency_format": "Dh {{amount}} MAD"
          },
          "MNT": {
            "money_format": "{{amount_no_decimals}} &#8366",
            "money_with_currency_format": "{{amount_no_decimals}} MNT"
          },
          "MZN": {
            "money_format": "{{amount}} Mt",
            "money_with_currency_format": "Mt {{amount}} MZN"
          },
          "NAD": {
            "money_format": "N${{amount}}",
            "money_with_currency_format": "N${{amount}} NAD"
          },
          "NPR": {
            "money_format": "Rs{{amount}}",
            "money_with_currency_format": "Rs{{amount}} NPR"
          },
          "ANG": {
            "money_format": "&fnof;{{amount}}",
            "money_with_currency_format": "{{amount}} NA&fnof;"
          },
          "NZD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} NZD"
          },
          "NIO": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "C${{amount}} NIO"
          },
          "NGN": {
            "money_format": "&#8358;{{amount}}",
            "money_with_currency_format": "&#8358;{{amount}} NGN"
          },
          "NOK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
          },
          "OMR": {
            "money_format": "{{amount_with_comma_separator}} OMR",
            "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
          },
          "PKR": {
            "money_format": "Rs.{{amount}}",
            "money_with_currency_format": "Rs.{{amount}} PKR"
          },
          "PGK": {
            "money_format": "K {{amount}}",
            "money_with_currency_format": "K {{amount}} PGK"
          },
          "PYG": {
            "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
          },
          "PEN": {
            "money_format": "S/. {{amount}}",
            "money_with_currency_format": "S/. {{amount}} PEN"
          },
          "PHP": {
            "money_format": "&#8369;{{amount}}",
            "money_with_currency_format": "&#8369;{{amount}} PHP"
          },
          "PLN": {
            "money_format": "{{amount_with_comma_separator}} zl",
            "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
          },
          "QAR": {
            "money_format": "QAR {{amount_with_comma_separator}}",
            "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
          },
          "RON": {
            "money_format": "{{amount_with_comma_separator}} lei",
            "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
          },
          "RUB": {
            "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
            "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
          },
          "RWF": {
            "money_format": "{{amount_no_decimals}} RF",
            "money_with_currency_format": "{{amount_no_decimals}} RWF"
          },
          "WST": {
            "money_format": "WS$ {{amount}}",
            "money_with_currency_format": "WS$ {{amount}} WST"
          },
          "SAR": {
            "money_format": "{{amount}} SR",
            "money_with_currency_format": "{{amount}} SAR"
          },
          "STD": {
            "money_format": "Db {{amount}}",
            "money_with_currency_format": "Db {{amount}} STD"
          },
          "RSD": {
            "money_format": "{{amount}} RSD",
            "money_with_currency_format": "{{amount}} RSD"
          },
          "SCR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} SCR"
          },
          "SGD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} SGD"
          },
          "SYP": {
            "money_format": "S&pound;{{amount}}",
            "money_with_currency_format": "S&pound;{{amount}} SYP"
          },
          "ZAR": {
            "money_format": "R {{amount}}",
            "money_with_currency_format": "R {{amount}} ZAR"
          },
          "KRW": {
            "money_format": "&#8361;{{amount_no_decimals}}",
            "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
          },
          "LKR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} LKR"
          },
          "SEK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
          },
          "CHF": {
            "money_format": "{{amount}} CHF",
            "money_with_currency_format": "{{amount}} CHF"
          },
          "TWD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TWD"
          },
          "THB": {
            "money_format": "{{amount}} &#xe3f;",
            "money_with_currency_format": "{{amount}} &#xe3f; THB"
          },
          "TZS": {
            "money_format": "{{amount}} TZS",
            "money_with_currency_format": "{{amount}} TZS"
          },
          "TTD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TTD"
          },
          "TND": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} DT"
          },
          "TRY": {
            "money_format": "{{amount}}TL",
            "money_with_currency_format": "{{amount}}TL"
          },
          "UGX": {
            "money_format": "Ush {{amount_no_decimals}}",
            "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
          },
          "UAH": {
            "money_format": "₴{{amount}}",
            "money_with_currency_format": "{{amount}} UAH"
          },
          "AED": {
            "money_format": "Dhs. {{amount}}",
            "money_with_currency_format": "Dhs. {{amount}} AED"
          },
          "UYU": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
          },
          "VUV": {
            "money_format": "{{amount}} VT",
            "money_with_currency_format": "{{amount}} VT"
          },
          "VEF": {
            "money_format": "Bs. {{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
          },
          "VND": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
          },
          "XBT": {
            "money_format": "{{amount_no_decimals}} BTC",
            "money_with_currency_format": "{{amount_no_decimals}} BTC"
          },
          "XOF": {
            "money_format": "CFA{{amount}}",
            "money_with_currency_format": "CFA{{amount}} XOF"
          },
          "ZMW": {
            "money_format": "K{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
          }
        };

  /* country -> currency, verbatim from the old theme */
  var COUNTRY_CURRENCY = {AF:"AFN",AX:"EUR",AL:"ALL",DZ:"DZD",AS:"USD",AD:"EUR",AO:"AOA",AI:"XCD",AQ:"",AG:"XCD",AR:"ARS",AM:"AMD",AW:"AWG",AU:"AUD",AT:"EUR",AZ:"AZN",BS:"BSD",BH:"BHD",BD:"BDT",BB:"BBD",BY:"BYN",BE:"EUR",BZ:"BZD",BJ:"XOF",BM:"BMD",BT:"BTN",BO:"BOB",BA:"BAM",BW:"BWP",BV:"NOK",BR:"BRL",IO:"USD",BN:"BND",BG:"BGN",BF:"XOF",BI:"BIF",KH:"KHR",CM:"XAF",CA:"CAD",CV:"CVE",KY:"KYD",CF:"XAF",TD:"XAF",CL:"CLP",CN:"CNY",CX:"AUD",CC:"AUD",CO:"COP",KM:"KMF",CG:"XAF",CD:"CDF",CK:"NZD",CR:"CRC",CI:"XOF",HR:"HRK",CU:"CUP",CY:"EUR",CZ:"CZK",DK:"DKK",DJ:"DJF",DM:"XCD",DO:"DOP",EC:"USD",EG:"EGP",SV:"USD",GQ:"XAF",ER:"ERN",EE:"EUR",ET:"ETB",FK:"FKP",FO:"DKK",FJ:"FJD",FI:"EUR",FR:"EUR",GF:"EUR",PF:"XPF",TF:"EUR",GA:"XAF",GM:"GMD",GE:"GEL",DE:"EUR",GH:"GHS",GI:"GIP",GR:"EUR",GL:"DKK",GD:"XCD",GP:"EUR",GU:"USD",GT:"GTQ",GG:"GBP",GN:"GNF",GW:"XOF",GY:"GYD",HT:"HTG",HM:"AUD",VA:"EUR",HN:"HNL",HK:"HKD",HU:"HUF",IS:"ISK",IN:"INR",ID:"IDR",IR:"IRR",IQ:"IQD",IE:"EUR",IM:"GBP",IL:"ILS",IT:"EUR",JM:"JMD",JP:"JPY",JE:"GBP",JO:"JOD",KZ:"KZT",KE:"KES",KI:"AUD",KR:"KRW",KW:"KWD",KG:"KGS",LA:"LAK",LV:"EUR",LB:"LBP",LS:"LSL",LR:"LRD",LY:"LYD",LI:"CHF",LT:"EUR",LU:"EUR",MO:"MOP",MK:"MKD",MG:"MGA",MW:"MWK",MY:"MYR",MV:"MVR",ML:"XOF",MT:"EUR",MH:"USD",MQ:"EUR",MR:"MRU",MU:"MUR",YT:"EUR",MX:"MXN",FM:"USD",MD:"MDL",MC:"EUR",MN:"MNT",ME:"EUR",MS:"XCD",MA:"MAD",MZ:"MZN",MM:"MMK",NA:"NAD",NR:"AUD",NP:"NPR",NL:"EUR",AN:"",NC:"XPF",NZ:"NZD",NI:"NIO",NE:"XOF",NG:"NGN",NU:"NZD",NF:"AUD",MP:"USD",NO:"NOK",OM:"OMR",PK:"PKR",PW:"USD",PS:"ILS",PA:"PAB",PG:"PGK",PY:"PYG",PE:"PEN",PH:"PHP",PN:"NZD",PL:"PLN",PT:"EUR",PR:"USD",QA:"QAR",RE:"EUR",RO:"RON",RU:"RUB",RW:"RWF",BL:"EUR",SH:"SHP",KN:"XCD",LC:"XCD",MF:"EUR",PM:"EUR",VC:"XCD",WS:"WST",SM:"EUR",ST:"STN",SA:"SAR",SN:"XOF",RS:"RSD",SC:"SCR",SL:"SLL",SG:"SGD",SK:"EUR",SI:"EUR",SB:"SBD",SO:"SOS",ZA:"ZAR",GS:"GBP",ES:"EUR",LK:"LKR",SD:"SDG",SR:"SRD",SJ:"NOK",SZ:"SZL",SE:"SEK",CH:"CHF",SY:"SYP",TW:"TWD",TJ:"TJS",TZ:"TZS",TH:"THB",TL:"USD",TG:"XOF",TK:"NZD",TO:"TOP",TT:"TTD",TN:"TND",TR:"TRY",TM:"TMT",TC:"USD",TV:"AUD",UG:"UGX",UA:"UAH",AE:"AED",GB:"GBP",US:"USD",UM:"USD",UY:"UYU",UZ:"UZS",VU:"VUV",VE:"VEF",VN:"VND",VG:"USD",VI:"USD",WF:"XPF",EH:"MAD",YE:"YER",ZM:"ZMW",ZW:"ZWD"};

  /* ------------------------------------------------------------------ utils */

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie =
      name + '=' + encodeURIComponent(value) + expires + '; path=/; domain=' + window.location.hostname;
  }

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i].replace(/^\s+/, '');
      if (c.indexOf(name + '=') === 0) {
        return decodeURIComponent(c.substring(name.length + 1));
      }
    }
    return null;
  }

  Currency.cookie = {
    configuration: { expires: 365, path: '/', domain: window.location.hostname },
    name: 'currency',
    write: function (currency) {
      setCookie(this.name, currency, this.configuration.expires);
    },
    read: function () {
      return getCookie(this.name);
    },
    destroy: function () {
      setCookie(this.name, '', -1);
    }
  };

  /* ------------------------------------------------------------ formatMoney */
  /* Ported verbatim from the old theme. */

  Currency.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  /* -------------------------------------------------------------- convertAll */

  var muted = false; // guards the MutationObserver against our own writes

  Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
    if (!newCurrency || !moneyFormats[newCurrency] || !moneyFormats[oldCurrency]) return;
    if (!Currency.rates || !Currency.rates[newCurrency] || !Currency.rates[oldCurrency]) return;

    muted = true;

    qsa(selector || PRICE_SELECTOR).forEach(function (el) {
      if (!el.getAttribute(dt_cur_shop)) {
        var getHtmlPrice = el.innerHTML;
        el.setAttribute(dt_cur_shop, getHtmlPrice);
        el.setAttribute(dt_base, getHtmlPrice);
        if (hover_currency && el.parentNode) {
          var wrap = document.createElement('span');
          wrap.className = 'ttip_currency';
          el.parentNode.insertBefore(wrap, el);
          wrap.appendChild(el);
          var tip = document.createElement('span');
          tip.className = 'tt_currency_txt';
          tip.innerHTML = getHtmlPrice;
          wrap.appendChild(tip);
        }
      }

      var baseAmount = el.getAttribute(dt_base);
      var cached = el.getAttribute('data-currency-' + newCurrency);

      if (newCurrency === shop_currency) {
        /* Shop currency: put back exactly what Shopify rendered rather than
           re-formatting it through the money table (which would turn
           "{{ shop money format }}" into the table's own INR format). */
        el.innerHTML = baseAmount;
      } else if (cached) {
        el.innerHTML = cached;
      } else {
        var newFormat = moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
        var cents = Currency.convert(
          parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, ''), 10) * 100,
          oldCurrency,
          newCurrency
        );
        if (round_currency) {
          cents = Math.round(cents / 100) * 100;
        }
        var newFormattedAmount = Currency.formatMoney(cents, newFormat);
        el.innerHTML = newFormattedAmount;
        el.setAttribute('data-currency-' + newCurrency, newFormattedAmount);
      }

      el.setAttribute('data-currency', newCurrency);

      var wrapper = el.parentNode;
      if (wrapper && wrapper.classList && wrapper.querySelector('.tt_currency_txt')) {
        if (hover_currency && newCurrency !== shop_currency) {
          wrapper.classList.add('ttip_currency');
        } else {
          wrapper.classList.remove('ttip_currency');
        }
      }
    });

    Currency.currentCurrency = newCurrency;

    qsa('.selected-currency').forEach(function (el) {
      el.textContent = newCurrency;
    });

    qsa('[data-currency-jsnotify]').forEach(function (el) {
      el.style.display = newCurrency === shop_currency ? 'none' : '';
    });

    muted = false;
  };

  /* --------------------------------------------------------------- selector */

  function markSelected(newCurrency, label) {
    qsa('.currencies .current').forEach(function (cur) {
      var previous = cur.getAttribute('data-flag');
      if (previous) cur.classList.remove('flags_bwp-' + previous);
      cur.classList.add('flags_bwp-' + newCurrency);
      cur.setAttribute('data-flag', newCurrency);
      cur.textContent = label || newCurrency;
    });
    qsa('.currencies .currency-item').forEach(function (a) {
      a.classList.remove('selected');
      a.removeAttribute('aria-current');
    });
    qsa('.currencies a[data-currency="' + newCurrency + '"]').forEach(function (a) {
      a.classList.add('selected');
      a.setAttribute('aria-current', 'true');
    });
  }

  function closeDropdowns() {
    qsa('.bwp_currency.show').forEach(function (el) {
      el.classList.remove('show');
      var toggle = el.querySelector('.header-selector__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function apply(newCurrency, label, persist) {
    markSelected(newCurrency, label);
    Currency.convertAll(shop_currency, newCurrency);
    closeDropdowns();
    if (persist) Currency.cookie.write(newCurrency);
  }

  /* --------------------------------------------------- convert late arrivals */

  function convertPending() {
    if (!Currency.currentCurrency) return;
    if (!document.querySelector(PRICE_SELECTOR + ':not([data-currency])')) return;
    Currency.convertAll(shop_currency, Currency.currentCurrency);
  }

  function watchForNewPrices() {
    if (typeof MutationObserver === 'undefined') return;
    var scheduled = false;
    new MutationObserver(function () {
      if (muted || scheduled) return;
      scheduled = true;
      var soon = window.requestAnimationFrame || function (fn) { return window.setTimeout(fn, 16); };
      soon(function () {
        scheduled = false;
        convertPending();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------ Currency_customer */

  Currency.Currency_customer = function (load) {
    var cookieCurrency = Currency.cookie.read();

    if (cookieCurrency) {
      apply(cookieCurrency, cookieCurrency, false);
    }

    if (load) {
      var selected = document.querySelector('.currencies a.currency-item.selected');
      if (selected) {
        Currency.convertAll(shop_currency, selected.getAttribute('data-currency'));
      }
      closeDropdowns();
      return;
    }

    /* open / close the dropdown (the old theme used Bootstrap's data-toggle) */
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('.bwp_currency .header-selector__toggle');
      if (toggle) {
        e.preventDefault();
        var wrapper = toggle.closest('.bwp_currency');
        var isOpen = wrapper.classList.contains('show');
        closeDropdowns();
        if (!isOpen) {
          wrapper.classList.add('show');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!(e.target.closest && e.target.closest('.bwp_currency'))) closeDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdowns();
    });

    /* currency click */
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.currencies a.currency-item');
      if (!link) return;
      e.preventDefault();
      if (link.classList.contains('selected')) {
        closeDropdowns();
        return;
      }
      apply(link.getAttribute('data-currency'), link.textContent.trim(), true);
    });

    /* hide currencies we have no money format for; the BWP <li> is the
       placeholder the geo lookup rewrites, so it stays */
    qsa('.currencies a.currency-item').forEach(function (a) {
      var code = a.getAttribute('data-currency');
      if (moneyFormats[code] === undefined && code !== 'BWP') {
        var li = a.closest('li');
        if (li) li.style.display = 'none';
      }
    });

    watchForNewPrices();

    if (auto_currency && !navigator.userAgent.match(/bot|spider/i)) {
      var dataUpdate = function (data) {
        var currencyCode = COUNTRY_CURRENCY[data.countryCode] || COUNTRY_CURRENCY[data.country] || data.currency;

        if (moneyFormats[currencyCode] !== undefined) {
          var existing = document.querySelector('.currencies a.currency-item.flags_bwp-' + currencyCode);
          if (!existing) {
            qsa('.currencies a.currency-item.flags_bwp-BWP').forEach(function (a) {
              a.textContent = currencyCode;
              a.classList.add('flags_bwp-' + currencyCode);
              a.setAttribute('data-currency', currencyCode);
              a.classList.remove('flags_bwp-BWP', 'dn');
              var li = a.closest('li');
              if (li) li.style.display = '';
            });
          } else {
            qsa('.currencies a.currency-item.flags_bwp-BWP').forEach(function (a) {
              var li = a.closest('li');
              if (li && li.parentNode) li.parentNode.removeChild(li);
            });
          }
          if (cookieCurrency == null) apply(currencyCode, currencyCode, false);
        } else {
          qsa('.currencies a.currency-item.flags_bwp-BWP').forEach(function (a) {
            var li = a.closest('li');
            if (li && li.parentNode) li.parentNode.removeChild(li);
          });
          if (cookieCurrency == null) apply(shop_currency, shop_currency, false);
        }
      };

      var cached = null;
      try {
        cached = window.localStorage.getItem('bwp_currency');
      } catch (err) {
        cached = null;
      }

      if (cached) {
        try {
          dataUpdate(JSON.parse(cached));
        } catch (err) {
          dataUpdate({ country: '' });
        }
      } else {
        /* ipinfo.io first: extreme-ip-lookup.com now needs an API key and
           always answers status:"fail", so it is only kept as a fallback. */
        var geo = function (url, ok, fail) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.timeout = 5000;
          xhr.onload = function () {
            var data = null;
            try {
              data = JSON.parse(xhr.responseText);
            } catch (err) {
              data = null;
            }
            if (data && data.status !== 'fail') {
              try {
                window.localStorage.setItem('bwp_currency', JSON.stringify(data));
              } catch (err) {
                /* private mode / quota - fine, we just re-fetch next time */
              }
              ok(data);
            } else {
              fail();
            }
          };
          xhr.onerror = fail;
          xhr.ontimeout = fail;
          xhr.send();
        };

        geo('https://ipinfo.io/json', dataUpdate, function () {
          geo('https://extreme-ip-lookup.com/json', dataUpdate, function () {
            if (cookieCurrency == null) apply(shop_currency, shop_currency, false);
          });
        });
      }
    } else {
      qsa('.currencies a.currency-item.flags_bwp-BWP').forEach(function (a) {
        var li = a.closest('li');
        if (li && li.parentNode) li.parentNode.removeChild(li);
      });
      if (cookieCurrency == null) apply(shop_currency, shop_currency, false);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      Currency.Currency_customer();
    });
  } else {
    Currency.Currency_customer();
  }
})();
